module.exports = __webpack_public_path__ + "static/media/Shop Description.2469ed66.jpg";